import React from 'react';
import { Col, Row } from "antd";
import * as moment from 'moment';

import ContainerHeader from "../../components/ContainerHeader";
import DefaultTimeLineItem from "../../components/timeline/DefaultTimeLineItem";


const StatusTimeline = React.memo(props => {
  const { title, data: timeLineData } = props;
  if (timeLineData && timeLineData.length > 0) {
    timeLineData.sort((a, b) => new Date(b.date) - new Date(a.date));
  }
  return (
    <Row>
      <Col span={24}>
        <ContainerHeader title={title} />
      </Col>
      <Col span={24}>
        <div className="gx-timeline-section">
          {timeLineData && timeLineData.length > 0 && timeLineData.map((timeLine, index) => {
            const { date, reviewDate, status, details, updatedBy } = timeLine;
            const timeLineData = {
              time: `Review Date : ${reviewDate ? moment(reviewDate).format('Do MMM, YYYY') : 'NA'}`,
              title: (status && status.name) || <small style={{ color: 'red' }}>Invalid Staus</small>,

              description: details || '',
              // alternativeTime: moment(reviewDate).format('DD-MM-YYYY'),
              subTitle: `Updated on ${date ? moment(date).format('Do MMM, YYYY') : 'NA'} by ${updatedBy && updatedBy.name}`,
            };
            return (<DefaultTimeLineItem key={index} timeLine={timeLineData} />);
          })}
        </div>
      </Col>
    </Row>
  )
});

StatusTimeline.propTypes = {};

export default StatusTimeline;
